import type { EntryValue, EntryValueT } from "@/types/database/entries";
import dayjs from "dayjs";
// Function to update a single entry value
export const updateEntryValues = (
	entryValues: EntryValueT[],
	newVal: Partial<EntryValueT>,
): EntryValueT[] => {
	// Find the index of the entry with matching input_id
	const index = entryValues.findIndex(
		(value) => value.input_id === newVal.input_id,
	);

	if (index !== -1) {
		const oldEntry = entryValues[index];
		// Create a new entry value with all required fields
		const updatedEntry: EntryValueT = {
			entry_id: oldEntry?.entry_id || "",
			entry_value_id: oldEntry?.entry_value_id || "",
			input_id: oldEntry?.input_id || "",
			last_edited: dayjs().toISOString(),
			number_value: oldEntry?.number_value || null,
			object_id: oldEntry?.object_id || null,
			text_array: oldEntry?.text_array || null,
			text_value: oldEntry?.text_value || null,
			created_at: oldEntry?.created_at || new Date().toISOString(),
			...newVal,
		};

		entryValues[index] = updatedEntry;
	} else {
		// If no existing entry is found
		// Add a new entry with the provided values and a new timestamp
		const newEntry: EntryValueT = {
			entry_id: newVal.entry_id || "",
			input_id: newVal.input_id || "",
			entry_value_id: newVal.entry_value_id || "",
			created_at: new Date().toISOString(),
			last_edited: null,
			number_value: null,
			object_id: null,
			text_array: null,
			text_value: null,
			...newVal,
		};

		entryValues.push(newEntry);
	}

	// Return the updated array
	return entryValues;
};

// Function to update multiple entry values
export const updateEntryValuesArray = (
	entryValues: EntryValueT[],
	newValues: Partial<EntryValueT>[],
): EntryValueT[] => {
	// Create a copy of the entryValues array to avoid reassigning the parameter
	let updatedEntryValues = [...entryValues];

	// Iterate through each new value
	for (const newVal of newValues) {
		// Update the entryValues array for each new value
		updatedEntryValues = updateEntryValues(updatedEntryValues, newVal);
	}

	// Return the final updated array
	return updatedEntryValues;
};
